import Commons from '../../../../Services/Common/Common';
import dayjs from 'dayjs';
export const CUL_BASIC_Schema = {
  fields: {
    coNm: { initial: '', label: '회사명', required: 'Y', requiredWhen: 'ADMIN' },
    name: { initial: '', label: '대표자(사업주)', required: 'Y', requiredWhen: 'ADMIN' },
    monthlyContractFee: {
      initial: '',
      label: '계약금(월)',
      required: 'Y',
      requiredWhen: 'ADMIN',
    },
    paymentDay: {
      initial: '',
      label: '결제일(매월)',
      required: 'Y',
      requiredWhen: 'ADMIN',
    },
  },
  mapper: {
    search1: {},
    search2: {
      CoCd: (_, context) => Commons.EncryptAES(context.CoCd || ''),
    },
    save1: {
      CoCd: (row) => Commons.EncryptAES(row.coCd),
      CustCd: (_, context) => Commons.EncryptAES(''),
      UserId: (_, context) => context.userInfo?.userid,
      Id: (row) => Commons.EncryptAES(row.id),
      EmployeeNo: (row) => Commons.EncryptAES('001'),
      MonthlyContractFee: (row) =>
        Commons.EncryptAES(String(row.monthlyContractFee ?? '')),
      PaymentDay: (row) => {
        const raw = row.paymentDay;
        if (raw === '' || raw === null || raw === undefined) {
          return Commons.EncryptAES('');
        }
        const n = Math.min(31, Math.max(1, Number(raw)));
        return Commons.EncryptAES(Number.isFinite(n) ? String(n) : '');
      },
      DepNm1: (row) => Commons.EncryptAES(String(row.depNm1 ?? '')),
      DepNm2: (row) => Commons.EncryptAES(String(row.depNm2 ?? '')),
      DepNm3: (row) => Commons.EncryptAES(String(row.depNm3 ?? '')),
      DepNm4: (row) => Commons.EncryptAES(String(row.depNm4 ?? '')),
      AuthCd: (row) => Commons.EncryptAES('BUSINESS_OWNER'),
      UseYn: (row) => Commons.EncryptAES(String(row.useYn ?? 'Y')),
      Position: (row) => Commons.EncryptAES(String(row.position ?? '')),
      Rank: (row) => Commons.EncryptAES(String(row.rank ?? '')),
      Name: (row) => Commons.EncryptAES(String(row.name ?? '')),
      Tel: (row) => Commons.EncryptAES(String(row.tel ?? '')),

      Birth: (row) =>
        Commons.EncryptAES(
          row.birth
            ? dayjs(row.birth).format('YYYY-MM-DD')
            : dayjs().format('YYYY-MM-DD')
        ),

      BloodType: (row) => Commons.EncryptAES(String(row.bloodType ?? '')),
      Address: (row) => Commons.EncryptAES(String(row.address ?? '')),
      Nation: (row) => Commons.EncryptAES(String(row.nation ?? '대한민국')),
      TbmYn: (row) => Commons.EncryptAES(String(row.tbmYn ?? 'N')),
      ApprovalYn: (row) => Commons.EncryptAES(String(row.approvalYn ?? 'N')),
      CoNm: (row) => Commons.EncryptAES(String(row.coNm)),
      Address1: (row) => Commons.EncryptAES(String(row.address1)),
      Address2: (row) => Commons.EncryptAES(String(row.address2)),
      ContractStartDate: (row) => Commons.EncryptAES(row.contractStartDate),
      ContractEndDate: (row) => Commons.EncryptAES(row.contractEndDate),
      ContractMemberCount: (row) => Commons.EncryptAES(row.contractMemberCount),
    },
  },
};
